import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=4c7a6d99&scoped=true"
import script from "./Treatment.vue?vue&type=script&lang=js"
export * from "./Treatment.vue?vue&type=script&lang=js"
import style0 from "./Treatment.vue?vue&type=style&index=0&id=4c7a6d99&prod&scoped=true&lang=css"
import style1 from "./Treatment.vue?vue&type=style&index=1&id=4c7a6d99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7a6d99",
  null
  
)

export default component.exports